import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import allImages from '../../../assets/images/allImages';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { isLogout } from '../../../Redux/authSlice';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './header.component.scss';

export const Header = (props) => {
  const authReducer = useSelector((state) => state.authReducer);
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location?.pathname);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // LOGOUT HANDLER
  const LogoutHandler = () => {
    dispatch(isLogout());
    navigate('/user/login');
  };

  const changeNavLink = () => {
    setCurrentPath(location.pathname);
  };

  useEffect(() => {
    // console.log(location.pathname)
    setCurrentPath(location.pathname);
  }, [location]);

  return (
    <>
      {/* <Navbar className="mt-4 mx-4" expand="lg" style={{ background: '#E6E9EC', maxHeight: '60px', borderRadius: '10px' }}  >
                <Container fluid style={{ padding: '0px' }}>
                    <Navbar.Brand href={'/enterprise/enterprise-admin'} className="fw-bolder fs-4 p-3" style={{ display: authReducer.role === 'enterprise-admin' ? 'block' : 'none' }}>Enterprise Logo</Navbar.Brand>
                    <Navbar.Brand href={"/enterprise/bond-admin"} className="fw-bolder fs-4 p-3" style={{ display: authReducer.role === 'bond-admin' ? 'block' : 'none' }}>
                        <img src={allImages.bondLogo} className='container-fluid' style={{ height: '2rem' }} />
                    </Navbar.Brand>
                    <Nav className="me-auto">
                      
                        <Nav.Link href={'/enterprise/enterprise-admin/upload-history'} className="fw-bold fs-6 mx-4" style={{ display: authReducer.role === 'enterprise-admin' ? 'block' : 'none' }}>Upload History</Nav.Link>
                        <Nav.Link href={'/enterprise/enterprise-admin/user-management'} className="fw-bold fs-6 mx-4" style={{ display: authReducer.role === 'enterprise-admin' ? 'block' : 'none' }}>User Management</Nav.Link>
                        <Nav.Link href={'/user/setting'} className="fw-bold fs-6 mx-4">Settings</Nav.Link>
                    </Nav>

                    <div className="d-flex align-items-center " >
                        <span className=' w-100 h-100' style={{ padding: '10px 18px 10px 18px', boxSizing: 'border-box' }}>
                            <span style={{ marginLeft: "2.5rem" }} className='fw-bolder cursor-pointer' onClick={() => LogoutHandler()}>Logout</span>
                        </span>
                    </div>
                </Container>
            </Navbar> */}

      {/* <!--begin::Left--> */}

      <div className="px-10 header d-flex align-items-stretch justify-content-between w-100 fixed-header">
        <Navbar
          expand="lg"
          className=" w-100 fixed-header"
          style={{ backgroundColor: '#ffffff', padding: '0px' }}
        >
          <Container
            fluid
            style={{
              margin: '0px',
              padding: '0px',
              backgroundColor: '#ffffff',
            }}
          >
            <Navbar.Brand
              href={
                authReducer.role === 'BOND_ADMIN'
                  ? '/enterprise/bond-admin/dashboard'
                  : '/enterprise/enterprise-admin/dashboard'
              }
              style={{
                marginRight: '20px',
                display:
                  authReducer.role === 'ENTERPRISE_ADMIN' ||
                  authReducer.role === 'ENTERPRISE_USER' ||
                  authReducer.role === 'BOND_ADMIN'
                    ? 'block'
                    : 'none',
              }}
              className="me-12"
            >
              <div className="aside-logo  ">
                <img
                  src={allImages.bondLogo}
                  className="container-fluid"
                  style={{ height: '2rem' }}
                  alt="bondLogo"
                />
              </div>
            </Navbar.Brand>

            <Nav
              className="me-auto my-2 my-lg-0 d-flex align-items-center nav-header"
              style={{ maxHeight: '100px' }}
              overlay={'true'}
            >
              <Nav.Link
                href={
                  authReducer.role === 'BOND_ADMIN'
                    ? '/enterprise/bond-admin/dashboard'
                    : '/enterprise/enterprise-admin/dashboard'
                }
                style={{
                  marginRight: '20px',
                  display:
                    authReducer.role === 'ENTERPRISE_USER' ||
                    authReducer.role === 'ENTERPRISE_ADMIN' ||
                    authReducer.role === 'BOND_ADMIN'
                      ? 'block'
                      : 'none',
                }}
                className="menu-item-header"
                onClick={() => changeNavLink()}
              >
                <div
                  className={
                    currentPath.includes(
                      authReducer.role === 'ENTERPRISE_ADMIN'
                        ? '/enterprise/enterprise-admin/dashboard'
                        : '/enterprise/bond-admin/dashboard',
                    )
                      ? ' menu-link  active-link py-2  '
                      : 'menu-link py-2 '
                  }
                >
                  <span className="menu-title">Home</span>
                </div>
              </Nav.Link>

              <Nav.Link
                href={'/enterprise/enterprise-admin/upload-history'}
                className="menu-item-header"
                onClick={() => changeNavLink()}
                style={{
                  display:
                    authReducer.role === 'ENTERPRISE_ADMIN'
                      ? 'block'
                      : 'none',
                }}
              >
                <div
                  className={
                    currentPath.includes(
                      '/enterprise/enterprise-admin/upload-history',
                    )
                      ? ' menu-link  active-link py-2  '
                      : 'menu-link py-2 '
                  }
                >
                  <span className="menu-title">Upload History</span>
                </div>
              </Nav.Link>

              <Nav.Link
                href={'/enterprise/enterprise-admin/user-management'}
                className="menu-item-header"
                onClick={() => changeNavLink()}
                style={{
                  display:
                    authReducer.role === 'ENTERPRISE_ADMIN'
                      ? 'block'
                      : 'none',
                }}
              >
                <div
                  className={
                    currentPath.includes(
                      '/enterprise/enterprise-admin/user-management',
                    )
                      ? ' menu-link  active-link py-2  '
                      : 'menu-link py-2 '
                  }
                >
                  <span className="menu-title">User Management</span>
                </div>
              </Nav.Link>
              <Nav.Link
                href={'/user/setting'}
                className="menu-item-header"
                onClick={() => changeNavLink()}
              >
                <div
                  className={
                    currentPath.includes('/user/setting')
                      ? ' menu-link  active-link py-2  '
                      : 'menu-link py-2 '
                  }
                >
                  <span className="menu-title">Settings</span>
                </div>
              </Nav.Link>
            </Nav>

            <div className="d-flex align-items-center ">
              <span
                className=" w-100 h-100"
                style={{
                  padding: '10px 18px 10px 18px',
                  boxSizing: 'border-box',
                }}
              >
                <span
                  style={{ marginLeft: '2.5rem' }}
                  className="fw-bolder cursor-pointer"
                  onClick={() => LogoutHandler()}
                >
                  Logout
                </span>
              </span>
            </div>
          </Container>
        </Navbar>
      </div>

      {/* <!--end::Left--> */}
    </>
  );
};
